"use client";

import { fnv1a } from '@core/helpers/string';
import {createContext, useContext, useEffect, useMemo, useState} from 'react';

export const WebSiteContext = createContext(null);

export const WebSiteContextProvider = ({children, setting = {}, route_names = {}, config_keys = [], logo_site = {}}) => {

    const [web_site_setting, set_web_site_setting] = useState(setting);
    const [web_route_names, set_web_route_names] = useState(route_names);

    useEffect(() => {
        console.log(
          "%cPowered by Shakhe Ara Infrastructure.\n© All rights reserved.\nhttps://shakheara.com/",
          "color: #4caf50; font-size: 12px;"
        );
    }, []);
    const check_service_access = (key) => {
        return config_keys?.includes(fnv1a(`service_key|${key}`));
    }

    const values = useMemo(() => ({
        web_site_setting,
        set_web_site_setting,
        web_route_names,
        set_web_route_names,
        check_service_access,
        logo_site
    }), [web_site_setting, web_route_names, config_keys,logo_site]);

    return (
        <WebSiteContext.Provider value={{...values}}>
            {children}
        </WebSiteContext.Provider>
    );
};

export const useWebSiteContext = () => useContext(WebSiteContext)